import { UnionMap } from '../types/union-map';

export type SingleDevCenterClientFailureCode = 'SingleDevCenterMissingUri' | 'SingleDevCenterInvalidUri';

export const SingleDevCenterClientFailureCode: UnionMap<SingleDevCenterClientFailureCode> = {
    SingleDevCenterInvalidUri: 'SingleDevCenterInvalidUri',
    SingleDevCenterMissingUri: 'SingleDevCenterMissingUri',
};
